import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@common/checkbox";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { ToggleArrow } from "./toggleArrow";
import { Props } from "./types";
import styles from "./styles.scss";

function FilterOptions({ filter, onFilterChange }: Props) {
  const { t } = useTranslation();

  const getSelectedFilters = () => {
    const selected = [];
    if (filter.includeDeactivated) {
      selected.push(t("timeSheet.deactivatedProjectsToggle"));
    }
    if (filter.includeRemovedFromProject) {
      selected.push(t("timeSheet.removedProjectsToggle"));
    }
    if (filter.includeCompletedTasks) {
      selected.push(t("timeSheet.workDoneToggle"));
    }
    if (filter.includeProjectsWithoutSpentTime) {
      selected.push(t("timeSheet.includeProjectsWithoutSpentTimeToggle"));
    }
    if (filter.includeProjectsWithoutSpentTimeInWeek) {
      selected.push(t("timeSheet.includeProjectsWithoutSpentTimeInWeekToggle"));
    }
    if (filter.includeProjectsWithoutNonIntegratedSpentTimeInWeek) {
      selected.push(
        t("timeSheet.includeProjectsWithoutNonIntegratedSpentTimeInWeekToggle"),
      );
    }

    return selected.length > 0
      ? selected.join(", ")
      : t("timeSheet.filters.default");
  };

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.optionsFilter, {
            [styles.opened]: isVisible,
          })}
        >
          <div className={styles.input} onClick={isVisible ? hide : show}>
            <p className={styles.selectedOptions}>{getSelectedFilters()}</p>
            <ToggleArrow className={styles.toggleArrow} />
          </div>

          {isVisible && (
            <div className={styles.list}>
              <div
                className={styles.item}
                onClick={() =>
                  onFilterChange({
                    ...filter,
                    includeDeactivated: !filter.includeDeactivated,
                  })
                }
              >
                <Checkbox isChecked={filter.includeDeactivated} />
                <p className={styles.typeName}>
                  {t("timeSheet.deactivatedProjectsToggle")}
                </p>
              </div>

              <div
                className={styles.item}
                onClick={() =>
                  onFilterChange({
                    ...filter,
                    includeRemovedFromProject:
                      !filter.includeRemovedFromProject,
                  })
                }
              >
                <Checkbox isChecked={filter.includeRemovedFromProject} />
                <p className={styles.typeName}>
                  {t("timeSheet.removedProjectsToggle")}
                </p>
              </div>

              <div
                className={styles.item}
                onClick={() =>
                  onFilterChange({
                    ...filter,
                    includeCompletedTasks: !filter.includeCompletedTasks,
                  })
                }
              >
                <Checkbox isChecked={filter.includeCompletedTasks} />
                <p className={styles.typeName}>
                  {t("timeSheet.workDoneToggle")}
                </p>
              </div>

              <div
                className={styles.item}
                onClick={() =>
                  onFilterChange({
                    ...filter,
                    includeProjectsWithoutSpentTime:
                      !filter.includeProjectsWithoutSpentTime,
                  })
                }
              >
                <Checkbox isChecked={filter.includeProjectsWithoutSpentTime} />
                <p className={styles.typeName}>
                  {t("timeSheet.includeProjectsWithoutSpentTimeToggle")}
                </p>
              </div>

              <div
                className={styles.item}
                onClick={() =>
                  onFilterChange({
                    ...filter,
                    includeProjectsWithoutSpentTimeInWeek:
                      !filter.includeProjectsWithoutSpentTimeInWeek,
                  })
                }
              >
                <Checkbox
                  isChecked={filter.includeProjectsWithoutSpentTimeInWeek}
                />
                <p className={styles.typeName}>
                  {t("timeSheet.includeProjectsWithoutSpentTimeInWeekToggle")}
                </p>
              </div>

              <div
                className={styles.item}
                onClick={() =>
                  onFilterChange({
                    ...filter,
                    includeProjectsWithoutNonIntegratedSpentTimeInWeek:
                      !filter.includeProjectsWithoutNonIntegratedSpentTimeInWeek,
                  })
                }
              >
                <Checkbox
                  isChecked={
                    filter.includeProjectsWithoutNonIntegratedSpentTimeInWeek
                  }
                />
                <p className={styles.typeName}>
                  {t(
                    "timeSheet.includeProjectsWithoutNonIntegratedSpentTimeInWeekToggle",
                  )}
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { FilterOptions };
